var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstacionCargaFuera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 225.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c90000;}.cls-2{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-estacion-carga-fuera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38",
    "data-name": 38
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.61,188.87c-11.87,0-23.85-6.89-23.85-22.28,0-8,4.57-13.89,8.25-18.67.57-.74,1.14-1.48,1.68-2.21,3.72-5.08,6.53-9.79,6.56-9.84l4.22-7.1a3.64,3.64,0,0,1,6.14-.17l4.61,6.85c0,.05,3.65,5.42,7.44,10.77l.84,1.18c3.66,5.12,8.21,11.49,8.21,19.84C122.71,180.38,113.25,188.87,98.61,188.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.22,36.83H64.77a6.43,6.43,0,0,0-6.42,6.42v48.3A6.43,6.43,0,0,0,64.77,98h68.45a6.42,6.42,0,0,0,6.42-6.42V43.25A6.42,6.42,0,0,0,133.22,36.83Zm-6.41,48.3H71.19V49.67h55.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.7,56.64H222.53c-1.32,0-4.8,0-7.31,2.69s-2.21,5.84-2.06,8c.05.74.11,1.5.11,2.36v76.1c0,2.17-.57,13-11.83,13-11.78,0-14.25-7.28-14.25-13.39v-25.5c0-2.57,0-6.87-3.15-10a9.93,9.93,0,0,0-7.27-2.85h-10V6.42A6.42,6.42,0,0,0,160.33,0h-123A6.42,6.42,0,0,0,30.9,6.42V212.58H6.42a6.42,6.42,0,1,0,0,12.84H192a6.42,6.42,0,1,0,0-12.84H166.75V119.86h7.6v25.55c0,12.1,7.1,26.22,27.09,26.22,19.51,0,24.66-16.92,24.66-25.87V69.47h22.6a6.42,6.42,0,1,0,0-12.83Zm-205,155.94V12.84H153.91V212.58Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstacionCargaFuera);
export default __webpack_public_path__ + "static/media/ic-estacion-carga-fuera.435ca2405a3ac6533e531e57d10091b0.svg";
export { ForwardRef as ReactComponent };